import { redactSensitiveText } from "../operations/securityEventSanitizer";
const noop = () => {};

const isProd =
  typeof process !== "undefined" &&
  process.env.NODE_ENV === "production";

const sanitizeArgs = (args = []) =>
  args.map((arg) => (typeof arg === "string" ? redactSensitiveText(arg) : arg));
const createEventOnlyLogger = (level) => (...args) => {
  emitOperationalEvent(level, args);
};

const emitOperationalEvent = (level, args) => {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }

  try {
    const safeArgs = sanitizeArgs(args);
    const message = safeArgs?.[0];
    window.dispatchEvent(
      new CustomEvent("db:operational-log", {
        detail: {
          level,
          category: level === "security" ? "security" : "operational",
          timestamp: new Date().toISOString(),
          message: typeof message === "string" ? message : redactSensitiveText(JSON.stringify(message || "")),
          context: safeArgs?.slice(1)?.map((item) =>
            typeof item === "string" ? item : redactSensitiveText(JSON.stringify(item))
          )
        }
      })
    );
  } catch {
    noop();
  }
};

const logger = {
  log: createEventOnlyLogger("log"),
  info: createEventOnlyLogger("info"),
  warn: (...args) => {
    const safeArgs = sanitizeArgs(args);
    emitOperationalEvent("warn", safeArgs);
    console.warn(...safeArgs);
  },
  error: (...args) => {
    const safeArgs = sanitizeArgs(args);
    emitOperationalEvent("error", safeArgs);
    console.error(...safeArgs);
  },
  debug: isProd ? noop : createEventOnlyLogger("debug"),
  security: (...args) => {
    const safeArgs = sanitizeArgs(args);
    emitOperationalEvent("security", safeArgs);
    console.error(...safeArgs);
  }
};

export default logger;
